import React from "react";
import classNames from "classnames";

import { ReactComponent as ChevronUpGrey } from "src/images/chevron-up-grey.svg";
import { Button } from "../Button/Button";

import "./Chevron.scss";

export function Chevron({ expanded, setExpanded, variant = "light-grey" }) {
  return (
    <Button
      variant={variant}
      size="small"
      className={classNames(["chevron", expanded && "chevron--expanded"])}
      onClick={(e) => {
        if (setExpanded) {
          e.stopPropagation();
          setExpanded((v) => !v);
        }
      }}
    >
      <ChevronUpGrey className="chevron__image" width={16} height={16} />
    </Button>
  );
}
